import { HeightModel } from './height.model';

export class AutoHeightModelFactory {
    public static build(): HeightModel {
        return new HeightModel(HeightModel.AUTO);
    }
}
